export const styles = {
  container: {
    margin: "auto",
    color: "blue.darkShade1",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-2rem",
    backgroundColor: "events.grayPrimary",
  },
  msg: {
    marginTop: "15px",
    textAlign: "center",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "28px",
    color: "text.primary",
  },
  desc: {
    marginTop: "10px",
    marginBottom: "30px",
    textAlign: "center",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "text.primary",
  },
};
